import { render, staticRenderFns } from "./SearchReservationsAdmin.vue?vue&type=template&id=d2fb0408&"
import script from "./SearchReservationsAdmin.vue?vue&type=script&lang=js&"
export * from "./SearchReservationsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports